module.exports = __webpack_public_path__ + "img/picture_kmskcspvip03.e58a9bee.png";